import styled from "styled-components";
import BackgroundGrid from "../../assets/bg-grid.svg";
import LoginBanner from "../../assets/login-banner.png";

export const LoginFormWrapper = styled.div`
  background-color: var(--bg-dark-blue);
  background-image: url(${BackgroundGrid});
  background-position: center;
  background-size: 100vw;

   min-height: 100dvh; /* Ensures full viewport height and handles mobile safari */
  display: flex;
  flex-direction: column;
  overflow-y: auto; /* Allows scrolling on small screens */
`;

export const Signin = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 80%;
  max-width: 1016px;

  @media (min-width: 2559px) {
  margin-top : 200px;
`;

export const SigninHeader = styled.div`
  background-color: var(--bg-light-blue);
  border-top-left-radius: 10px;
  padding: 50px 150px 50px 100px;
  margin-bottom: -7px;

  
`;

export const PlayerData = styled.div`
  border-top: 5px double var(--highlight);
  background-color: var(--bg-light-blue);
  padding: 70px 150px 40px 100px;

  display: flex;
  flex-direction: column;
  gap: 20px;

  flex: 1;

  
`;

export const SigninWrapper = styled.div`
  
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  margin-left: 200px;
  margin-right: 200px;

  flex: 1;
`;

export const Input = styled.input`
  background-color: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px solid var(--text-light);

  color: var(--highlight);

  font-family: "Source Serif 4", serif;

  font-weight: 700;
  line-height: 40px;
  font-size: 30px;

  &:focus {
    outline: none;
  }
`;

export const SideContainer = styled.div`
  background-color: var(--text-light);
  background-image: url(${LoginBanner});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  border-top-right-radius: 10px;
  width: 398px;

  @media (min-width: 2559px) {
  margin-top : 200px;

`;


export const ModalButton = styled.button`
  font-family: "Manrope";
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: #fffbec;
  text-decoration: underline;
  cursor: pointer;
  background-color: transparent;
  border: none;
  text-align: left;
  margin-top: 5px;
`;

// ✅ Style for error message
export const ErrorMessage = styled.p`
  color: rgb(255, 255, 255);
  font-size: 18px;
  margin-top: 10px;
  text-align: center;
`;
